if ( typeof ProductPage !== 'function' ) {

	// Mock KROWN object for testing
	if (typeof KROWN === 'undefined') {
		window.KROWN = {
			settings: {
				cart_action: 'overlay'
			}
		};
	}

	// Mock KEYCODES for testing
	if (typeof window.KEYCODES === 'undefined') {
		window.KEYCODES = {
			RETURN: 13
		};
	}

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Initialize addon functionality only if variant addons exist on the page
		if (this.querySelector('.variant-addons')) {
			this.initializeAddons();
			// Initialize addon display for current variant on page load
			this.initializeAddonDisplay();
		} else {
			// Hide .addons-msg if no variant addons exist on the page
			const addonsMsg = this.querySelector('.addons-msg');
			if (addonsMsg) {
				addonsMsg.style.display = 'none';
			}
		}

			// Initialize addon messages display
			this.initializeAddonMessages();

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {

				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});

				// refresh color
				this.querySelectorAll('.product-variant__item--radio input').forEach(input=>{
					input.addEventListener('click', () => {
						const inputParent = input.closest('.product-variant__item--radio');
						if ( inputParent.classList.contains('product-variant__item--color' ) ) {
							inputParent.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = input.value;
						}
					})
				});

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
							if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							if ( variantImg.getBoundingClientRect().top > window.innerHeight ) {		
								variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
							} else if ( variantImg.getBoundingClientRect().top < 0 ) {
								variantImg.scrollIntoView({behavior: 'smooth', block: 'center'});
							}
						}
					}
				}
				
				// variant addons handling - only if variant addons exist on the page
			if (this.querySelector('.variant-addons')) {
				this.handleVariantAddons(variant.id);
			}
			
			// Handle addon messages display
			this.handleAddonMessages(variant.sku);
				
				this.querySelectorAll('.product-variant__item--color [data-selected]').forEach(elm=>{
					elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.value;
				});

			}

		}

		handleVariantAddons(variantId) {
		// Only proceed if variant addons exist on the page
		if (!this.querySelector('.variant-addons')) {
			return;
		}

		// Hide all variant addons first and uncheck their checkboxes
		this.querySelectorAll('.variant-addons').forEach(addon => {
			addon.classList.remove('show');
			// Uncheck all addon checkboxes when hiding
			addon.querySelectorAll('.addon-checkbox').forEach(checkbox => {
				checkbox.checked = false;
			});
			// Reset addon quantities to 0 or 1 (depending on your preference)
			addon.querySelectorAll('.addon-quantity').forEach(quantity => {
				quantity.value = '0'; // or '1' if you want default quantity of 1
			});
		});
	
		// Show the addon for the current variant
		const currentVariantAddon = this.querySelector(`.variant-addons[data-variant-id="${variantId}"]`);
		if (currentVariantAddon) {
			currentVariantAddon.classList.add('show');
		}

		// Show/hide .addons-msg based on whether any variant addons are visible
		const addonsMsg = this.querySelector('.addons-msg');
		if (addonsMsg) {
			const hasVisibleAddons = this.querySelector('.variant-addons.show');
			if (hasVisibleAddons) {
				addonsMsg.style.display = 'block';
			} else {
				addonsMsg.style.display = 'none';
			}
		}
	}

		initializeAddons() {
		// Only proceed if variant addons exist on the page
		if (!this.querySelector('.variant-addons')) {
			return;
		}

		// Set up event listeners for addon checkboxes and quantity selectors
		this.addEventListener('change', (e) => {
			if (e.target.classList.contains('addon-checkbox') || e.target.classList.contains('addon-quantity')) {
				this.handleAddonChange(e);
			}
		});

		// Override the main product form submission to include addons
		const productForm = this.querySelector('[data-js-product-form]');
		if (productForm) {
			productForm.addEventListener('submit', (e) => {
				e.preventDefault();
				this.handleProductWithAddonsSubmit(e);
			});
		}
	}

		initializeAddonDisplay() {
		// Only proceed if variant addons exist on the page
		if (!this.querySelector('.variant-addons')) {
			return;
		}

		// Get the current variant ID from the product variants component
		const productVariants = this.querySelector('product-variants[data-main-product-variants]');
		if (productVariants && productVariants.currentVariant) {
			this.handleVariantAddons(productVariants.currentVariant.id);
		} else {
			// Fallback: look for the first visible addon container
			const firstVisibleAddon = this.querySelector('.variant-addons.show');
			if (firstVisibleAddon) {
				const variantId = firstVisibleAddon.dataset.variantId;
				if (variantId) {
					this.handleVariantAddons(variantId);
				}
			}
		}
	}

		handleAddonChange(e) {
			// This method can be used for real-time updates if needed
			// For now, we'll handle everything on form submission
		}

		handleProductWithAddonsSubmit(e) {
		console.log('🛒 Form submission started');
		const form = e.target;
		const formData = new FormData(form);
		
		// Get main product data
		const mainProductId = formData.get('id');
		const mainProductQuantity = parseInt(formData.get('quantity') || '1');

		console.log('📋 Form data:', {
			mainProductId,
			mainProductQuantity,
			formDataEntries: Array.from(formData.entries())
		});

		// Prepare items array for cart
		const items = [
			{
				id: mainProductId,
				quantity: mainProductQuantity
			}
		];

		// Only collect and add addons if variant addons exist on the page
		if (this.querySelector('.variant-addons')) {
			// Collect selected addons
			const selectedAddons = this.getSelectedAddons();
			console.log('🎯 Selected addons:', selectedAddons);

			// Add selected addons to items array
			selectedAddons.forEach(addon => {
				items.push({
					id: addon.variantId,
					quantity: addon.quantity
				});
			});
		}

		console.log('📦 Final items array:', items);

		// Add all items to cart
		this.addItemsToCart(items, form);
	}

		getSelectedAddons() {
		console.log('🔍 Getting selected addons...');
		const addons = [];
		
		// Only proceed if variant addons exist on the page
		if (!this.querySelector('.variant-addons')) {
			console.log('📍 No variant addons found on page');
			return addons;
		}
		
		const visibleAddonContainer = this.querySelector('.variant-addons.show');
		console.log('📍 Visible addon container:', visibleAddonContainer);
		
		if (visibleAddonContainer) {
			const checkedBoxes = visibleAddonContainer.querySelectorAll('.addon-checkbox:checked');
			console.log('✅ Checked boxes found:', checkedBoxes.length);
			
			checkedBoxes.forEach((checkbox, index) => {
				const addonItem = checkbox.closest('.addon-item');
				const quantitySelect = addonItem.querySelector('.addon-quantity');
				const variantId = checkbox.dataset.id;
				const quantity = parseInt(quantitySelect.value);
				
				console.log(`📋 Addon ${index + 1}:`, {
					variantId,
					quantity,
					checkboxElement: checkbox,
					quantityElement: quantitySelect
				});
				
				addons.push({
					variantId: variantId,
					quantity: quantity
				});
			});
		}
		
		console.log('🎯 Final selected addons:', addons);
		return addons;
	}

		addItemsToCart(items, form) {
			console.log('Adding items to cart:', items);
			
			// First, preload cart content to ensure it's ready for updates
			this.preloadCartContent().then(() => {
				// Now add items to cart
				const requestBody = {
					items: items
				};

				return fetch(window.Shopify.routes.root + 'cart/add.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest'
					},
					body: JSON.stringify(requestBody)
				});
			})
			.then(response => {
				console.log('Cart API response status:', response.status);
				if (response.ok) {
					return response.json();
				} else {
					// Try to get error details
					return response.text().then(text => {
						console.error('Cart API error response:', text);
						throw new Error(`Failed to add items to cart: ${response.status} - ${text}`);
					});
				}
			})
			.then(data => {
				console.log('Cart API success response:', data);
				
				// Trigger the add-to-cart event for theme compatibility
				form.dispatchEvent(new CustomEvent('add-to-cart', {
					bubbles: true,
					detail: { items: data.items || data }
				}));
				
				// Update cart UI with proper timing
				return this.updateCartUIWithDelay(data);
			})
			.catch(error => {
				console.error('Error adding items to cart:', error);
				// Show user-friendly error message
				alert('There was an error adding items to cart. Please try again.');
			});
		}

		preloadCartContent() {
			// Preload cart content to ensure it's ready for updates
			return fetch(window.Shopify.routes.root + 'cart.js')
				.then(response => response.json())
				.then(cart => {
					console.log('Cart preloaded:', cart);
					// Store current cart state for comparison
					this.previousCartState = cart;
					return cart;
				})
				.catch(error => {
					console.error('Error preloading cart:', error);
					return null;
				});
		}

		updateCartUIWithDelay(cartData) {
			// Update cart UI with proper timing to ensure content is refreshed
			return new Promise((resolve) => {
				// First update: immediate
				if (typeof window.KROWN !== 'undefined' && window.KROWN.cart) {
					if (typeof window.KROWN.cart.refreshCart === 'function') {
						window.KROWN.cart.refreshCart();
					}
					window.KROWN.cart.updateCartCount();
				}
				
				// Second update: after 50ms to allow for initial processing
				setTimeout(() => {
					this.refreshCartDisplay();
					
					// Third update: after 150ms to ensure content is fully loaded
					setTimeout(() => {
						const cartSidebar = document.getElementById('site-cart-sidebar');
						if (cartSidebar) {
							// Try to refresh cart content before showing
							if (typeof cartSidebar.refreshCart === 'function') {
								cartSidebar.refreshCart();
							} else if (typeof cartSidebar.updateCart === 'function') {
								cartSidebar.updateCart();
							}
							
							// Final refresh to ensure all content is updated
							this.refreshCartDisplay();
							
							// Show the cart sidebar
							cartSidebar.show();
						}
						resolve(cartData);
					}, 150);
				}, 50);
			});
		}

		refreshCartDisplay() {
			// Fetch current cart state
			fetch(window.Shopify.routes.root + 'cart.js')
				.then(response => response.json())
				.then(cart => {
					// Dispatch custom event with cart data
					document.dispatchEvent(new CustomEvent('cart:updated', {
						detail: { cart: cart }
					}));
					
					// Try to update cart sidebar content
					const cartSidebar = document.getElementById('site-cart-sidebar');
					if (cartSidebar) {
						if (typeof cartSidebar.updateContent === 'function') {
							cartSidebar.updateContent(cart);
						} else {
							// Fallback: reload cart sidebar content
							this.reloadCartSidebar(cartSidebar);
						}
					}
				})
				.catch(error => {
					console.error('Error refreshing cart display:', error);
				});
		}

		reloadCartSidebar(cartSidebar) {
			// Fetch the cart drawer HTML
			fetch(window.location.href)
				.then(response => response.text())
				.then(html => {
					const parser = new DOMParser();
					const doc = parser.parseFromString(html, 'text/html');
					const newCartContent = doc.getElementById('site-cart-sidebar');
					
					if (newCartContent) {
						// Try to update specific content areas first
						const currentCartItems = cartSidebar.querySelector('.cart-items, .site-cart__items, [data-cart-items]');
						const newCartItems = newCartContent.querySelector('.cart-items, .site-cart__items, [data-cart-items]');
						
						if (currentCartItems && newCartItems) {
							currentCartItems.innerHTML = newCartItems.innerHTML;
						} else {
							// Fallback: replace entire sidebar content
							cartSidebar.innerHTML = newCartContent.innerHTML;
						}
						
						// Update cart count if element exists
						const cartCount = document.querySelector('.cart-count, [data-cart-count]');
						const newCartCount = doc.querySelector('.cart-count, [data-cart-count]');
						if (cartCount && newCartCount) {
							cartCount.textContent = newCartCount.textContent;
						}
					}
				})
				.catch(error => {
					console.error('Error reloading cart sidebar:', error);
				});
		}

		initializeAddonMessages() {
			// Initialize addon messages display on page load
			const productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if (productVariants && productVariants.currentVariant) {
				this.handleAddonMessages(productVariants.currentVariant.sku);
			} else {
				// Fallback: show default message (111)
				this.handleAddonMessages(null);
			}
		}

		handleAddonMessages(variantSku) {
			// Hide all addon messages first
			const allAddonMessages = this.querySelectorAll('.addons-msg');
			allAddonMessages.forEach(msg => {
				msg.style.display = 'none';
			});

			// Check if variant has visible addons - if no visible addons exist, keep all messages hidden
			if (!this.querySelector('.variant-addons.show')) {
				return; // No visible addons exist, keep all messages hidden (including default 111)
			}

			// Try to find matching message by variant SKU
			let targetMessage = null;
			if (variantSku) {
				targetMessage = this.querySelector(`.addons-msg[data-variant-sku="${variantSku}"]`);
			}

			// If no matching message found or no SKU provided, show default (111)
			if (!targetMessage) {
				targetMessage = this.querySelector('.addons-msg[data-variant-sku="111"]');
			}

			// Show the target message
			if (targetMessage) {
				targetMessage.style.display = 'block';
			}
		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI ) 
					model.modelViewerUI.pause()
			});
		}
		
		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}